import React from 'react';
import HeaderInner from '../header/HeaderInner';
import BreadcrumbBlog from '../inner/breadcrumb/BreadcrumbBlog';
import Footer from '../elements/Footer';
import { Link } from 'react-router-dom';

function ServiceDetails() {
  const blogPosts = [
  {
    img: "assets/images/blog/blog-2.png",
    date: "20 JUL 2025",
    category: "Audit & Compliance",
    title: "Why Timely Auditing Builds Business Trust",
    summary:
      "Timely auditing is essential for identifying financial gaps, improving accountability, and ensuring regulatory alignment. It enhances trust, prevents compliance issues, and supports sustainable business growth.",
  },
  {
    img: "assets/images/blog/blog-3.png",
    date: "18 JUL 2025",
    category: "ERP Consulting",
    title: "ERP Integration That Improves Operations",
    summary:
      "ERP systems integrate business functions like HR, finance, and supply chain, streamlining operations. They reduce manual errors, enhance real-time decisions, and drive overall organizational efficiency.",
  },
  {
    img: "assets/images/blog/blog-1.png",
    date: "15 JUL 2025",
    category: "Tax & VAT",
    title: "Avoid VAT Penalties with Smart Planning",
    summary:
      "Proper VAT planning prevents errors, missed filings, and penalties. With expert guidance, businesses can maintain compliance, reduce tax-related risks, and adapt to changing regulatory frameworks.",
  },
  {
    img: "assets/images/blog/blog-4.png",
    date: "10 JUL 2025",
    category: "Business Setup",
    title: "Steps to Prepare Before Company Launch",
    summary:
      "Before starting a business, ensure all legal, financial, and structural elements are in place. This includes licenses, systems, and strategy—providing a strong foundation for long-term success.",
  },
  {
    img: "assets/images/blog/blog-5.png",
    date: "08 JUL 2025",
    category: "Financial Advisory",
    title: "How SMEs Benefit from Financial Planning",
    summary:
      "SMEs grow faster with financial planning that ensures healthy cash flow, clear budgeting, and realistic goals. It boosts confidence with investors and helps track business performance consistently.",
  },
  {
    img: "assets/images/blog/blog-6.png",
    date: "05 JUL 2025",
    category: "Outsourced Accounting",
    title: "Outsourcing Accounting for Better Control",
    summary:
      "Outsourcing accounting saves costs while accessing expert services. It eliminates hiring overhead, improves reporting accuracy, and gives businesses more flexibility in managing their finances.",
  },
];


  return (
    <div className="service-details">
      <HeaderInner />
      <main>
        <BreadcrumbBlog />

        {/* Blog area start */}
        <div className="altest-blog-area tmp-section-gap">
          <div className="container">
            <div className="row g-5">
              {blogPosts.map((post, index) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={index}>
                  <div className="single-blog blog-style-three">
                    <div className="blog-inner">
                      <div className="thumbnail">
                        <img src={post.img} alt={post.title} />
                      </div>
                      <div className="blog-content" >
                        <div className="blog-head" >
                          {/* <span className="name">{post.date}</span> */}
                          <span className="designation">{post.category}</span>
                        </div>
                        <div className="blog-body">
                          <h4 className="title" style={{ textAlign: 'left' }}>{post.title}</h4>
                          <p className="description" style={{textAlign:"justify"}}>{post.summary}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Blog area end */}

        <Footer />
      </main>
    </div>
  );
}

export default ServiceDetails;
